<template>
  <b-button
    :variant="isConnected ? 'success' : 'primary'"
    size="sm"
    class="!p-[10px] !px-[12px] !flex items-center justify-center gap-[8px]"
    :disabled="isSynced || disabled"
    @click="handleClick"
  >
    <b-spinner
      v-if="isLoading"
      small
      variant="white"
    />
    <slot />
  </b-button>
</template>

<script>
export default {
  name: 'BtnConnectProduct',

  props: {
    isConnected: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSynced: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    setLoading(isLoading) {
      this.isLoading = isLoading
    },
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>
